/** Localize ECO / opening book display names via Header UI language. */
export function openingNameKey(name) {
  return String(name || '')
    .toLowerCase()
    .replace(/['']/g, '')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '');
}

export function localizeOpeningName(name, t) {
  if (!name) return '';
  const key = openingNameKey(name);
  if (!key) return String(name);
  return t(`playing.openings.${key}`, { defaultValue: String(name) });
}
